var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-header",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    md: "6"
                  }
                },
                [
                  _vm._v(" Accounts List "),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "ml-2 mb-1",
                      attrs: {
                        secondary: ""
                      },
                      on: {
                        click: function click($event) {
                          return _vm.$router.push(_vm.addAccountPath)
                        }
                      }
                    },
                    [_vm._v(" Add Account ")]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "text-right",
                  attrs: {
                    md: "6"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "font-sm"
                    },
                    [
                      _vm.short
                        ? _c(
                            "router-link",
                            {
                              attrs: {
                                to: _vm.listAccountsPath
                              }
                            },
                            [_vm._v("View All Accounts →")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        secondary: ""
                      },
                      on: {
                        click: function click($event) {
                          return _vm.launch_whm(_vm.$route.params.hostingid)
                        }
                      }
                    },
                    [
                      _vm._v(" WHM Access "),
                      _c(
                        "v-icon",
                        {
                          staticClass: "pl-2",
                          attrs: {
                            small: ""
                          }
                        },
                        [_vm._v(" mdi-open-in-new ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "gg-card-text",
        [
          _c(
            "table-wrapper",
            [
              _c("v-data-table", {
                attrs: {
                  id: "my-table",
                  items: _vm.items,
                  loading: _vm.isLoading,
                  headers: _vm.tableHeaders
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function fn(_ref) {
                      var item = _ref.item,
                        isMobile = _ref.isMobile,
                        headers = _ref.headers
                      return [
                        isMobile
                          ? _c(
                              "tr",
                              {
                                staticClass: "v-data-table__mobile-table-row",
                                style: {
                                  backgroundColor: item.suspended
                                    ? " #FFB8B8"
                                    : ""
                                }
                              },
                              _vm._l(headers, function(header) {
                                return _c(
                                  "td",
                                  {
                                    key: "header-".concat(header.value),
                                    staticClass: "v-data-table__mobile-row"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "v-data-table__mobile-row__header"
                                      },
                                      [_vm._v(_vm._s(header.text))]
                                    ),
                                    header.value === "plan"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-data-table__mobile-row__cell"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.textTruncate(
                                                    _vm.formatPackageNameForTable(
                                                      item.plan
                                                    ),
                                                    16
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "ml-1 mb-1",
                                                attrs: {
                                                  small: "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.openPlanModal(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(" mdi-pencil ")]
                                            )
                                          ],
                                          1
                                        )
                                      : header.value === "actions"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-data-table__mobile-row__cell"
                                          },
                                          [
                                            !item.suspended
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-right"
                                                  },
                                                  [
                                                    _c(
                                                      "gg-btn",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          disabled: !!item.suspended,
                                                          to: {
                                                            path: "/hosting/shared/".concat(
                                                              _vm.hosting.id
                                                            ),
                                                            query: {
                                                              user: item.user
                                                            }
                                                          }
                                                        }
                                                      },
                                                      [_vm._v(" Manage ")]
                                                    ),
                                                    !_vm.short
                                                      ? [
                                                          _c(
                                                            "gg-btn",
                                                            {
                                                              staticClass:
                                                                "mr-2 text-none",
                                                              attrs: {
                                                                tile: "",
                                                                secondary: ""
                                                              },
                                                              on: {
                                                                click: function click(
                                                                  $event
                                                                ) {
                                                                  return _vm.launch_cpanel(
                                                                    _vm.$route
                                                                      .params
                                                                      .hostingid,
                                                                    item.user
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " cPanel "
                                                              ),
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "pl-2",
                                                                  attrs: {
                                                                    small: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " mdi-open-in-new "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      : _vm._e(),
                                                    _c(
                                                      "v-menu",
                                                      {
                                                        attrs: {
                                                          "offset-y": "",
                                                          left: ""
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function fn(
                                                                _ref2
                                                              ) {
                                                                var on =
                                                                    _ref2.on,
                                                                  attrs =
                                                                    _ref2.attrs
                                                                return [
                                                                  _c(
                                                                    "gg-btn",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "primary",
                                                                            icon:
                                                                              ""
                                                                          }
                                                                        },
                                                                        "gg-btn",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      on
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-dots-vertical"
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      },
                                                      [
                                                        _c(
                                                          "v-list",
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                on: {
                                                                  click: function click(
                                                                    $event
                                                                  ) {
                                                                    return _vm.openChangePasswordModal(
                                                                      item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "pb-1",
                                                                        attrs: {
                                                                          small:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-lock"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " Password Management "
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                attrs: {
                                                                  disabled:
                                                                    item.isMain
                                                                },
                                                                on: {
                                                                  click: function click(
                                                                    $event
                                                                  ) {
                                                                    return _vm.openSuspendModal(
                                                                      item.user,
                                                                      item.suspended
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "pb-1",
                                                                        attrs: {
                                                                          small:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-cancel"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    item.suspended
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              " Unsuspend Account "
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              " Suspend Account "
                                                                            )
                                                                          ]
                                                                        )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                attrs: {
                                                                  disabled:
                                                                    item.isMain
                                                                },
                                                                on: {
                                                                  click: function click(
                                                                    $event
                                                                  ) {
                                                                    return _vm.openDeleteModal(
                                                                      item.user
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "pb-1",
                                                                        attrs: {
                                                                          small:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-trash-can-outline"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " Delete Account "
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-right"
                                                  },
                                                  [
                                                    _c(
                                                      "gg-btn",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          secondary: ""
                                                        },
                                                        on: {
                                                          click: function click(
                                                            $event
                                                          ) {
                                                            return _vm.openSuspendModal(
                                                              item.user,
                                                              item.suspended
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v(" Unsuspend ")]
                                                    )
                                                  ],
                                                  1
                                                )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "v-data-table__mobile-row__cell"
                                          },
                                          [_vm._v(_vm._s(item[header.value]))]
                                        )
                                  ]
                                )
                              }),
                              0
                            )
                          : _c(
                              "tr",
                              {
                                style: {
                                  backgroundColor: item.suspended
                                    ? " #FFB8B8"
                                    : ""
                                }
                              },
                              [
                                _c("td", [
                                  _vm._v(" " + _vm._s(item.user) + " ")
                                ]),
                                _c("td", [
                                  _vm._v(" " + _vm._s(item.domain) + " ")
                                ]),
                                _c("td", [_vm._v(" " + _vm._s(item.ip) + " ")]),
                                _c("td", [
                                  _vm._v(" " + _vm._s(item.quota) + " ")
                                ]),
                                _c("td", [
                                  _vm._v(" " + _vm._s(item.diskUsed) + " ")
                                ]),
                                _c("td", [
                                  _c(
                                    "div",
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.textTruncate(
                                              _vm.formatPackageNameForTable(
                                                item.plan
                                              ),
                                              16
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "ml-1 mb-1",
                                          attrs: {
                                            small: "",
                                            color: "primary"
                                          },
                                          on: {
                                            click: function click($event) {
                                              return _vm.openPlanModal(item)
                                            }
                                          }
                                        },
                                        [_vm._v(" mdi-pencil ")]
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _c("td", [
                                  !item.suspended
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "text-right"
                                        },
                                        [
                                          _c(
                                            "gg-btn",
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                disabled: !!item.suspended,
                                                to: {
                                                  path: "/hosting/shared/".concat(
                                                    _vm.hosting.id
                                                  ),
                                                  query: {
                                                    user: item.user
                                                  }
                                                }
                                              }
                                            },
                                            [_vm._v(" Manage ")]
                                          ),
                                          !_vm.short
                                            ? [
                                                _c(
                                                  "gg-btn",
                                                  {
                                                    staticClass:
                                                      "mr-2 text-none",
                                                    attrs: {
                                                      tile: "",
                                                      secondary: ""
                                                    },
                                                    on: {
                                                      click: function click(
                                                        $event
                                                      ) {
                                                        return _vm.launch_cpanel(
                                                          _vm.$route.params
                                                            .hostingid,
                                                          item.user
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(" cPanel "),
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "pl-2",
                                                        attrs: {
                                                          small: ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " mdi-open-in-new "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            : _vm._e(),
                                          _c(
                                            "v-menu",
                                            {
                                              attrs: {
                                                "offset-y": "",
                                                left: ""
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function fn(_ref3) {
                                                      var on = _ref3.on,
                                                        attrs = _ref3.attrs
                                                      return [
                                                        _c(
                                                          "gg-btn",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "primary",
                                                                  icon: ""
                                                                }
                                                              },
                                                              "gg-btn",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-dots-vertical"
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _c(
                                                "v-list",
                                                [
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      on: {
                                                        click: function click(
                                                          $event
                                                        ) {
                                                          return _vm.openChangePasswordModal(
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "pb-1",
                                                              attrs: {
                                                                small: ""
                                                              }
                                                            },
                                                            [_vm._v("mdi-lock")]
                                                          ),
                                                          _vm._v(
                                                            " Password Management "
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: {
                                                        disabled: item.isMain
                                                      },
                                                      on: {
                                                        click: function click(
                                                          $event
                                                        ) {
                                                          return _vm.openSuspendModal(
                                                            item.user,
                                                            item.suspended
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "pb-1",
                                                              attrs: {
                                                                small: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-cancel"
                                                              )
                                                            ]
                                                          ),
                                                          item.suspended
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  " Unsuspend Account "
                                                                )
                                                              ])
                                                            : _c("span", [
                                                                _vm._v(
                                                                  " Suspend Account "
                                                                )
                                                              ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: {
                                                        disabled: item.isMain
                                                      },
                                                      on: {
                                                        click: function click(
                                                          $event
                                                        ) {
                                                          return _vm.openDeleteModal(
                                                            item.user
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-title",
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "pb-1",
                                                              attrs: {
                                                                small: ""
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-trash-can-outline"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " Delete Account "
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        2
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "text-left"
                                        },
                                        [
                                          _c(
                                            "gg-btn",
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                secondary: ""
                                              },
                                              on: {
                                                click: function click($event) {
                                                  return _vm.openSuspendModal(
                                                    item.user,
                                                    item.suspended
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(" Unsuspend ")]
                                          )
                                        ],
                                        1
                                      )
                                ])
                              ]
                            )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "confirmation-modal",
        {
          attrs: {
            loading: _vm.deleteModal.loading
          },
          on: {
            cancel: _vm.closeDeleteModal,
            confirm: _vm.deleteSubAccount
          },
          model: {
            value: _vm.deleteModal.show,
            callback: function callback($$v) {
              _vm.$set(_vm.deleteModal, "show", $$v)
            },
            expression: "deleteModal.show"
          }
        },
        [
          _c("p", [
            _vm._v(
              'Do you really want to delete "' +
                _vm._s(_vm.deleteModal.username) +
                '" account?'
            )
          ]),
          _c("p", [_vm._v("All data will be lost and cannot be recovered.")])
        ]
      ),
      _c(
        "confirmation-modal",
        {
          attrs: {
            loading: _vm.suspendModal.loading
          },
          on: {
            cancel: _vm.closeSuspendModal,
            confirm: _vm.switchSubAccountStatus
          },
          model: {
            value: _vm.suspendModal.show,
            callback: function callback($$v) {
              _vm.$set(_vm.suspendModal, "show", $$v)
            },
            expression: "suspendModal.show"
          }
        },
        [
          _c("p", [
            _vm._v(
              " Do you really want to " +
                _vm._s(_vm.suspendModal.suspended ? "unsuspend" : "suspend") +
                ' "' +
                _vm._s(_vm.suspendModal.username) +
                '" account? '
            )
          ])
        ]
      ),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.modalUpdateEmail
        },
        on: {
          close: _vm.closeUpdateEmailModal
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Update Email ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("v-text-field", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.modalUpdateEmail ? "required|email" : "",
                      expression: "modalUpdateEmail ? 'required|email': ''"
                    }
                  ],
                  attrs: {
                    label: "E-mail for ".concat(_vm.user),
                    outlined: "",
                    "data-vv-name": "email",
                    "data-vv-as": "Email",
                    disabled: _vm.isUpdatingEmail,
                    "error-messages": _vm.errors.collect("email")
                  },
                  model: {
                    value: _vm.email,
                    callback: function callback($$v) {
                      _vm.email = typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "email"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      secondary: ""
                    },
                    on: {
                      click: _vm.closeUpdateEmailModal
                    }
                  },
                  [_vm._v(" Cancel ")]
                ),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: "",
                      loading: _vm.isUpdatingEmail
                    },
                    on: {
                      click: _vm.updateContactEmail
                    }
                  },
                  [_vm._v(" Update ")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.modalUpdatePlan
        },
        on: {
          close: _vm.closePlanModal
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Update Plan ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("gg-select", {
                  attrs: {
                    outlined: "",
                    label: "Plan for ".concat(_vm.user),
                    items: _vm.planOptions
                  },
                  model: {
                    value: _vm.plan,
                    callback: function callback($$v) {
                      _vm.plan = $$v
                    },
                    expression: "plan"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      secondary: ""
                    },
                    on: {
                      click: _vm.closePlanModal
                    }
                  },
                  [_vm._v(" Cancel ")]
                ),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: "",
                      loading: _vm.isUpdatingPlan
                    },
                    on: {
                      click: _vm.updatePlan
                    }
                  },
                  [_vm._v(" Update ")]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.modalChangePassword
        },
        on: {
          close: _vm.closeChangePasswordModal
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [_vm._v(" Change Password ")]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c("compact-password", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.modalChangePassword ? "required|min:8" : "",
                      expression: "modalChangePassword ? 'required|min:8' : ''"
                    }
                  ],
                  attrs: {
                    outlined: "",
                    "cpanel-app": "passwd",
                    label: "New Password for ".concat(_vm.user),
                    "show-strength": "",
                    "with-generator": "",
                    charset:
                      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMOPRSTUVWXYZ0123456789_",
                    autocomplete: "new-password",
                    "data-vv-name": "password",
                    "data-vv-as": "Password",
                    "error-messages": _vm.errors.collect("password")
                  },
                  model: {
                    value: _vm.password,
                    callback: function callback($$v) {
                      _vm.password = $$v
                    },
                    expression: "password"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      secondary: ""
                    },
                    on: {
                      click: _vm.closeChangePasswordModal
                    }
                  },
                  [_vm._v(" Cancel ")]
                ),
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: "",
                      loading: _vm.isUpdatingPassword
                    },
                    on: {
                      click: _vm.updatePassword
                    }
                  },
                  [_vm._v(" Change ")]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }